import { render, staticRenderFns } from "./comorbiditiesTableOverview.vue?vue&type=template&id=57170642&scoped=true"
import script from "./comorbiditiesTableOverview.vue?vue&type=script&lang=ts"
export * from "./comorbiditiesTableOverview.vue?vue&type=script&lang=ts"
import style0 from "./comorbiditiesTableOverview.vue?vue&type=style&index=0&id=57170642&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57170642",
  null
  
)

export default component.exports